// extracted by mini-css-extract-plugin
export default {"filters":"ProjectFilters_filters__rsM+N","searchInput":"ProjectFilters_searchInput__+c0vo","select":"ProjectFilters_select__MkHQh"};